define('SageDotCom/DataLayer/Util/scrollHelper',['jquery'], function ($) {

    function scrollHelper() { }

    // parses a url and returns an object representing a file if found
    scrollHelper.prototype.percentScrolled = function percentScrolled() {
        var winheight = $(window).height();
        var docheight = $(document).height();
        var scrollTop = $(window).scrollTop();
        var trackLength = docheight - winheight;
        var pctScrolled = Math.floor(scrollTop / trackLength * 100); // gets percentage scrolled (ie: 80 NaN if tracklength == 0)

        return pctScrolled;
    }

    return new scrollHelper();
});
